export var SourceAccountSortField;
(function (SourceAccountSortField) {
    SourceAccountSortField["SOURCE_ACCOUNT_SORT_ACCOUNT_NAME"] = "accountName";
    SourceAccountSortField["SOURCE_ACCOUNT_SORT_INSTALLED_VERSION"] = "installedVersion";
    SourceAccountSortField["SOURCE_ACCOUNT_SORT_PARENT_IDENTIFIER"] = "parentIdentifier";
    SourceAccountSortField["SOURCE_ACCOUNT_SORT_FIRST_CONNECTED"] = "createdAt";
})(SourceAccountSortField || (SourceAccountSortField = {}));
